import {
    StringSplitConstant
} from "../Constant/String/StringSplitConstant";

// 將傳進的參數斷行
export function contentSplitSupport(content) {
    let content_after_split = content.split(StringSplitConstant.SPLIT_CHARACTER);

    return content_after_split;
}